import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';

import {Link} from 'shells/link/link';

import {Field} from 'redux-form';

import {TinyIntroCheckbox} from '../../fields/tiny-intro-checkbox';

import {LOGIN_FORM_REMEMBER_ME_FIELD} from '../login-form';

import styles from '../login-form.module.css';

type Props = {
    emailValue: string | null | undefined;
};

export function OptionsSection(props: Props) {
    return (
        <div className={styles['label']}>
            <Field
                key='remember_me'
                name={LOGIN_FORM_REMEMBER_ME_FIELD}
                title='Stay logged in?'
                component={TinyIntroCheckbox}
            />
            <Link
                // @ts-expect-error
                as={RouterLink}
                to={{
                    pathname: '/auth/forgot-password',
                    search: props.emailValue ? `?email=${props.emailValue}` : undefined,
                }}
                variant='primary'
            >
                Forgot password?
            </Link>
        </div>
    );
}
